export const ChecklistIcon = () => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 15H4.35c-.358 0-.701-.146-.955-.405a1.403 1.403 0 01-.395-.98v-9.23c0-.368.142-.72.395-.98.254-.26.597-.405.955-.405h2.777c.239 0 .468.097.637.27l3.972 4.075a.935.935 0 01.264.653v2.808"
        stroke="#142A31"
        strokeLinejoin="round"
      />
      <path
        d="M7 3v3.947A1.053 1.053 0 008.053 8H12M5 10h4M5 12h2"
        stroke="#142A31"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14a4.001 4.001 0 00-8 0 4.001 4.001 0 008 0z"
        stroke="#142A31"
        strokeMiterlimit="10"
      />
      <path
        d="M15.5 12.5l-2 3-1-1.5"
        stroke="#142A31"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
